import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import FactorialPhysicalCard from 'assets/images/factorial-physical-card.svg'
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion'

const AnimatedCard = () => {
  const x = useMotionValue(250)
  const y = useMotionValue(150)

  const centeredX = useSpring(
    useTransform(x, (n) => n - 600),
    {
      bounce: 1,
      stiffness: 800,
      damping: 80,
    }
  )

  const centeredY = useSpring(
    useTransform(y, (n) => n - 600),
    {
      bounce: 1,
      stiffness: 800,
      damping: 80,
    }
  )

  const hoverState = useMotionValue(0)
  const hoverOpacity = useSpring(hoverState)

  const rotateX = useSpring(useTransform(y, [0, 300], [-10, 10]), {
    bounce: 1,
    stiffness: 800,
    damping: 80,
  })

  const rotateY = useSpring(useTransform(x, [0, 500], [10, -10]), {
    bounce: 1,
    stiffness: 800,
    damping: 80,
  })

  const handleMouse = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const rect = event.currentTarget.getBoundingClientRect()
    hoverState.set(1)
    x.set(event.clientX - rect.left)
    y.set(event.clientY - rect.top)
  }

  const mouseLeave = () => {
    hoverState.set(0)
    x.set(250)
    y.set(150)
  }

  return (
    <Box
      style={{
        display: 'flex',
        placeItems: 'center',
        placeContent: 'center',
        perspective: '400px',
      }}
    >
      <motion.div
        onMouseLeave={mouseLeave}
        onMouseMove={handleMouse}
        whileHover={{
          scale: 1.02,
          boxShadow: '0px 10px 20px 0px rgba(0, 0, 0, 0.10)',
          transform: 'translateY(-14px)',
        }}
        whileInView={{
          rotateY: [0, 0, 0, 5, -5, 0],
          rotateX: [0, 0, 0, 5, -5, 0],
          transition: {
            type: 'spring',
            bounce: 0.4,
            duration: 2,
          },
        }}
        style={{
          width: 339,
          height: 209,
          borderRadius: 14,
          boxShadow: '0px 5px 10px 0px rgba(0, 0, 0, 0.10)',
          rotateX: rotateX,
          rotateY: rotateY,
          overflow: 'hidden',
        }}
      >
        <Box borderRadius={{ all: 'abs016' }} boxShadow="s50">
          <img src={FactorialPhysicalCard} height="100%" width="100%" />
        </Box>

        <motion.div
          style={{
            width: 1200,
            height: 1200,
            background:
              'radial-gradient(closest-side, rgba(255,255,255,.05), rgba(255,255,255,0)) 60%',
            opacity: hoverOpacity,
            x: centeredX,
            y: centeredY,
          }}
        ></motion.div>
      </motion.div>
    </Box>
  )
}

export default AnimatedCard
